import { useContext, useEffect } from "react";
import { Context } from "../Context";
import { useHistory } from "react-router-dom";

const Home = () => {
  const context = useContext(Context);
  const loggedInAs = localStorage.getItem("loggedInAs");
  const history = useHistory();

  useEffect(() => {
    context.setNavActiveKey("home");
    if (!loggedInAs) {
      history.push("/");
    }
  }, [context, history, loggedInAs]);

  return (
    <>
      <div className="p-5">
        <h6 className="mb-3">Admin portal modules: </h6>
        {loggedInAs === "cognito" ? (
          <ul>
            <li>Provision Wall Controller</li>
            <li>Update Mac Pin</li>
          </ul>
        ) : (
          <ul>
            <li>Feature Flag Management</li>
            <li>Provisioning status</li>
          </ul>
        )}
      </div>
    </>
  );
};

export default Home;
